// P-MILESTONE-DERIVATION — /play/day-complete route.
//
// Mounts the day-end "story unlocked" celebration. Reached from the Mixed
// recap on the 3rd completion (PART E) and from PathHome's auto-navigation
// gate on a /play mount when the day is complete and no story is picked yet
// (PART B/D). The screen fetches its own milestone events + story catalog,
// so the route is a plain component mount (no search params).

import { createFileRoute } from "@tanstack/react-router";
import { DayCompleteCelebration } from "@/screens/DayCompleteCelebration";
// MA-928 — on an armed class door device, 4 minutes without input return to
// the door (no button here; renders nothing on an unarmed device).
import { KioskHandoff, KIOSK_DOOR_PATH, useKioskDoorDevice } from "@/components/KioskHandoff";

export const Route = createFileRoute("/play/day-complete")({
  component: DayCompleteRoute,
});

function DayCompleteRoute() {
  // MA-928 (D-1013-23) — on a class door device the Back home exits go to the door, replacing history.
  const door = useKioskDoorDevice();
  return (
    <>
      <DayCompleteCelebration homeTo={door ? KIOSK_DOOR_PATH : undefined} homeReplace={door ? true : undefined} />
      <KioskHandoff allDone={false} />
    </>
  );
}
